import React, { useState, useCallback, useEffect } from 'react'
import { MagnifyingGlassIcon } from '../LandingHeader/Feedback/icons/Icons';
import debounce from 'lodash/debounce';
import { Route, Routes, useNavigate, useSearchParams } from 'react-router-dom';
import TasksSearchResults from '../../pages/Tasks/TasksSearchResults';

const TaskSearchInput = ({showModal = true, autoFocus = false}) => {
    const [searchKey, setSearchKey] = useState('');
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const keyword = searchParams.get('keyword');
        setSearchKey(keyword ?? '');
    }, [searchParams])
    
    // Debounced search function
    const debouncedSearch = useCallback(
        debounce((value) => {
            showModal
            ?
            (
                value.length > 0
                ?
                navigate(`/search?keyword=${value}`)
                :
                navigate(process.env.REACT_APP_ROOT)
            )
            :
            navigate(`/tasks/search?keyword=${value}`)
        }, 300),
        []
    );

    const searchHandler = (e) => {
        const {value} = e.target;
        setSearchKey(value);
        debouncedSearch(value);
    }

    return (
        <>
            <div className="relative w-full">
                <input type='text' id="task-search-input" className='search-field w-full font text-black dark:text-white dark:placeholder:text-white2' onInput={searchHandler} value={searchKey} placeholder='Search tasks...' autoFocus={autoFocus} />
                <span className="absolute right-5 top-3 search-lens"><MagnifyingGlassIcon /></span>
            </div>
            <Routes>
                <Route path='/search' element={<TasksSearchResults />} />
            </Routes>
        </>
    )
}

export default TaskSearchInput
